import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Übersicht',
      href: '/de/Aussenkameras/IN-9020_HD/',
    },
    {
      text: 'Spezifikationen',
      href: '/de/Aussenkameras/IN-9020_HD/Technische_Spezifikationen/',
    },
    {
      text: 'Features',
      href: '/de/Aussenkameras/IN-9020_HD/Produkt_Features/',
    },
    {
      text: 'Installation',
      href: '/de/Aussenkameras/IN-9020_HD/Schnell_Installation/',
    },
    {
      text: 'Objektivjustage',
      href: '/de/Aussenkameras/IN-9020_HD/Objektivjustage/',
    },
    {
      text: 'Handbuch',
      href: '/de/Aussenkameras/IN-9020_HD/Handbuch/',
    },
    {
      text: '◄ Aussenkameras',
      href: '/de/Aussenkameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-9020 Full HD Online Usermanual Chapters"
      />
      <EuiSpacer />
    </Fragment>
  );
}

// export default () => {
//   const breadcrumbs = [
//     {
//       text: 'Overview',
//       href: '/Aussenkameras/IN-9020_HD/',
//     },
//     {
//       text: 'Technical Specifications',
//       href: '/Aussenkameras/IN-9020_HD/Technical_Specifications/',
//     },
//     {
//       text: 'Product Features',
//       href: '/Aussenkameras/IN-9020_HD/Product_Features/',
//     },
//     {
//       text: 'Installation',
//       href: '/Aussenkameras/IN-9020_HD/Quick_Installation/',
//     },
//     {
//       text: 'Lense Adjustment',
//       href: '/Aussenkameras/IN-9020_HD/Lense_Adjustment/',
//     },
//     {
//       text: '◄ Usermanual',
//       href: '/Aussenkameras/IN-9020_HD/Usermanual/',
//     }
//   ];

//   return (
//     <Fragment>
//       <EuiBreadcrumbs
//         truncate={true}
//         breadcrumbs={breadcrumbs}
//         max={6}
//         aria-label="INSTAR IN-9020 Full HD Online Usermanual Chapters"
//       />
//       <EuiSpacer />
//     </Fragment>
//   );
// }